import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConvertGoodsAttributeService {
  /**
   * コンストラクタ
   */
  constructor(private http: HttpClient) { }

  /**
   * チェーンリスト取得API呼び出し
   */
   public initialize(organization: string): Observable<any> {
    const httpOptions: any = {
      params: { 'organization': organization }
    };
    return this.http.get(environment.apiEndPoint + 'api/convert-goods/initialize', httpOptions) as Observable<any>;
  }

  /**
   * 変換表ファイル検証API呼び出し
   * @param formData フォームデータ
   */
  public testConvertGoodsAttribute(formData: FormData): Observable<any> {
    return this.http.post(environment.apiEndPoint + 'api/convert-goods/test', formData) as Observable<any>;
  }

  /**
   * 変換結果ファイル取得API呼び出し
   */
   public getTestResultFile(outputFileName:string): Observable<any> {
    let httpOptions: any = {
      responseType: 'blob',
      headers: new HttpHeaders({
        'contet-type': 'application/octet-stream',
      }),
      params: {
        'outputFileName': outputFileName,
      }
    };

    return this.http.get(environment.apiEndPoint + 'api/convert-goods/get-test-result-file', httpOptions);
  }

  /**
   * 変換表ファイル本番適応API呼び出し
   * @param formData フォームデータ
   */
  public applyConvertGoodsAttribute(formData: FormData): Observable<any> {
    return this.http.post(environment.apiEndPoint + 'api/convert-goods/apply', formData) as Observable<any>;
  }

  /**
   * 変換定義ルールファイル取得API呼び出し
   */
  public getDefineFile(isChain:string, organization: string, chainCd:string=null): Observable<any> {
    let httpOptions: any = {
      responseType: 'blob',
      headers: new HttpHeaders({
        'contet-type': 'application/octet-stream',
      }),
      params: {
        'isChain': isChain,
        'chainCd': chainCd,
        'organization': organization
      }
    };

    return this.http.get(environment.apiEndPoint + 'api/convert-goods/get-define-file', httpOptions);
  }
}
